import React from 'react';
import coach360SrcPyramid from 'images/logos/coach360-pyramid.svg';
import './TriggerUserAvatar.styl';

export default class TriggerUserAvatar extends React.Component {
  render() {
    return <img alt="user avatar" className="trigger-user-avatar" src={coach360SrcPyramid} />;
  }
}
